import { Component, Input } from '@angular/core';
import { Client } from 'src/typings';

@Component({
  selector: 'app-client-list-new',
  templateUrl: './client-list-new.component.html',
  styleUrls: ['./client-list-new.component.scss']
})
export class ClientListNewComponent {
  @Input() clients: Client[] = [];
}
